import { createBrowserHistory } from 'history'

const history = createBrowserHistory({
  basename: '/chec',
})

export default history
